var map = {
	"./404_images/404.png": "9wLW",
	"./404_images/404_cloud.png": "VD6r",
	"./BG59.jpg": "27bi",
	"./BG60.png": "0NGg",
	"./dataicon.png": "LPmq",
	"./download.png": "aHOS",
	"./exprod.png": "Dpwe",
	"./eye-close.png": "gOw/",
	"./eye-open.png": "YUF6",
	"./homeBoard/menu_icon.png": "jrGk",
	"./icon_bussini.png": "IptA",
	"./icon_butie.png": "ljiX",
	"./icon_coin.png": "+wJJ",
	"./icon_data.png": "9pKd",
	"./icon_down.png": "OTUl",
	"./icon_home.png": "7Cw6",
	"./icon_jd.png": "IBD4",
	"./icon_mp.png": "ZKpz",
	"./icon_old.png": "LLBa",
	"./icon_order.png": "zjs4",
	"./icon_payment.png": "8BHn",
	"./icon_recycle.png": "dL4R",
	"./icon_settlement.png": "lVoS",
	"./icon_sys.png": "Y5i1",
	"./icon_third.png": "AJfP",
	"./icon_user.png": "FUny",
	"./loginLogo.png": "Zx/2",
	"./ordericon.png": "ku6G",
	"./recyclingicon.png": "bWlZ",
	"./remind.png": "71sA",
	"./setupicon.png": "iLzo",
	"./sibarbg.png": "ttA9",
	"./sighicon.png": "HnUg",
	"./success.png": "mzrL",
	"./titleIcon.png": "9jz6",
	"./trashicon.png": "AlBF",
	"./user.png": "8tHC",
	"./usericon.png": "ur+s",
	"./warning.png": "QcOD"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "PvXa";


//////////////////
// WEBPACK FOOTER
// ./src/assets ^\.\/.*$
// module id = PvXa
// module chunks = 1